import { useCallback, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';

import { useMembership } from '@ocx/data-membership';
import { useRegisterPushNotifications } from '../../../modules/notifications/useRegisterPushNotifications';
import { useSyncPushNotificationPermissionState } from '../../../modules/communication-preference/useSyncPushNotificationPermissionState';

export const useHomePushNotificationsEffect = () => {
  const { membership } = useMembership();
  const { registerPushNotifications } = useRegisterPushNotifications();
  const syncPushNotificationPermissionState = useSyncPushNotificationPermissionState();

  const updateCommunicationPreference = useCallback(
    async (customerId: string, oldIsOptedIn: boolean) => {
      if (!Capacitor.isPluginAvailable('PushNotifications')) {
        return;
      }

      const { receive: newState } = await PushNotifications.checkPermissions();
      syncPushNotificationPermissionState({
        customerId,
        oldIsOptedIn,
        newState,
      });
    },
    [syncPushNotificationPermissionState],
  );

  useEffect(() => {
    updateCommunicationPreference(membership.customerId, membership.communicationPreference.pushOptIn);
  }, [membership, updateCommunicationPreference]);

  useEffect(() => {
    registerPushNotifications();
  }, [registerPushNotifications]);
};
